import React from "react";
import { ImCross } from "react-icons/im";
import { RecipientSelectionMode } from "./RecipientSelectorTypes";

export interface RecipientListItem {
  id: number;
  fullName: string;
  email?: string;
  contactValue?: string;
}

interface RecipientListProps {
  recipients: RecipientListItem[];
  selectionMode: RecipientSelectionMode;
  onRemoveRecipient?: (userId: number) => void;
  onAddToManual?: () => void;
  isLoading?: boolean;
  showAddToManual?: boolean;
  maxHeight?: string;

  // Customization
  renderRecipientInfo?: (recipient: RecipientListItem) => React.ReactNode;
}

export const RecipientList: React.FC<RecipientListProps> = ({
  recipients,
  selectionMode,
  onRemoveRecipient,
  onAddToManual,
  isLoading = false,
  showAddToManual = true,
  maxHeight = "max-h-52",
  renderRecipientInfo,
}) => {
  if (recipients.length === 0) {
    return null;
  }

  const defaultRenderRecipientInfo = (recipient: RecipientListItem) => (
    <>
      <span>{recipient.fullName}</span>
      {recipient.email && <span className="text-gray-500 dark:text-gray-400">({recipient.email})</span>}
      {recipient.contactValue && <span className="text-gray-500 dark:text-gray-400">({recipient.contactValue})</span>}
    </>
  );

  return (
    <div className={`${maxHeight} overflow-y-auto rounded border bg-white dark:border-gray-600 dark:bg-gray-800`}>
      {recipients.map((recipient) => (
        <div
          key={recipient.id}
          className="flex items-center justify-between border-b border-gray-100 px-3 py-2 text-sm text-gray-700 last:border-b-0 hover:bg-gray-50 dark:border-gray-700 dark:text-gray-300 dark:hover:bg-gray-700"
        >
          <div className="flex items-center gap-2">
            <div className="h-2 w-2 rounded-full bg-green-500 dark:bg-green-400"></div>
            {renderRecipientInfo ? renderRecipientInfo(recipient) : defaultRenderRecipientInfo(recipient)}
          </div>
          {(selectionMode === "manual" || selectionMode === "waitlist") && onRemoveRecipient && (
            <ImCross
              onClick={() => onRemoveRecipient(recipient.id)}
              className="cursor-pointer text-red-500 hover:text-red-700 dark:text-red-400 dark:hover:text-red-300"
              title="Usuń odbiorcę"
            />
          )}
        </div>
      ))}
    </div>
  );
};
